import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output, SimpleChange } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Usuario, Usuarios } from 'app/models/usuarios.model';
import { SolicitudesService } from 'app/modules/admin/solicitudes/solicitudes.service';
import { Observable } from 'rxjs';
import { CONSTANTS } from 'app/core/constants';


@Component({
    selector: 'add-user-avatar',
    imports:[CommonModule, MatIconModule, MatMenuModule, MatTooltipModule],
    templateUrl: 'add-user-avatar.component.html'
})

export class AddUserAvatarComponent implements OnInit {
    @Output() usuarioSeleccionado:EventEmitter<Usuario>= new EventEmitter<Usuario>();

    usuarios$ :  Observable<Usuario[]>   
    safeName: string = '';

    idUsuariosAdministradores: number = CONSTANTS.ID_ROL_ADMINISTRADOR
    
    constructor(private solicitudesService: SolicitudesService) {

        this.usuarios$=this.solicitudesService.usuarios$

    }

    ngOnInit(): void {}


    selecccionarUsuario(usuario:Usuario){
        this.usuarioSeleccionado.next(usuario)
    }
}
